module.exports = __webpack_public_path__ + "img/3.5747b518.jpg";